import { cn } from './cn.js';

export interface SpinnerProps {
  size?: number;
  className?: string;
}

export function Spinner({ size = 20, className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={cn(
        'inline-block animate-spin rounded-full border-2 border-line border-t-brand',
        className,
      )}
      style={{ width: size, height: size }}
    />
  );
}

export function FullScreenLoader({ label }: { label?: string }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-canvas">
      <Spinner size={28} />
      {label ? <p className="text-sm text-muted">{label}</p> : null}
    </div>
  );
}
